import { type SWRResponse } from 'swr';

import type ApiError from '@/helpers/ApiError';
import { type UseNoodleSwrConfig, useNoodleSwr } from '@/hooks/useNoodleApi';
import noodleApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleApi';
import buildPath from '@/tsClient/utilities/buildPath';

const PATH_TEMPLATE = '/my/profile';

export type ProfileApi = ApiDefinition[typeof PATH_TEMPLATE]['GET'];

export const useProfile = (
  params?: null,
  config?: UseNoodleSwrConfig<ProfileApi['response']>,
): SWRResponse<ProfileApi['response'], ApiError> => {
  const path = buildPath<ProfileApi>(PATH_TEMPLATE);
  return useNoodleSwr(path, { revalidateOnFocus: false, ...config });
};

/**
 * @deprecated: Please use `useProfile` wherever a perfectly fresh response is not worth the network time, bandwidth, and compute.
 */
const getProfile = async (): Promise<ProfileApi['response']> => {
  const path = buildPath<ProfileApi>(PATH_TEMPLATE);
  const data = await noodleApiClient.get(path);
  return data.data;
};

export default getProfile;
